<template>
  <div>
    <div v-if="is_loading" class="is-flex is-justify-content-center">
      <div class="loading"></div>
    </div>
    <div v-if="is_loading == false">
      <div v-if="show_company_search_form">
        <p class="text_align_center">אנא חפש/י את חברת "<b>{{ payload.company.name }}</b>" במערכת Accounting.</p>
        <div class="is-flex is-align-items-center is-justify-content-center">
          <p><b>חיפוש חברה</b>:</p>
          <div class="horizontal_space"></div>
          <input class="outlined" placeholder="הרצוג" v-model="company_search_term" @input="searchCompany">
        </div>
        <div class="search_results">
          <div @click="selectCompanySearchResult(company)" class="search_result" v-for="company in companies_search_results" :key="company.id">
            <p class="m-0">{{ company.name }}</p>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="vertical_space"></div>
        <p v-if="is_create" class="section_title"><b>יצירת חברה חדשה</b>:</p>
        <p v-else class="section_title"><b>פרטי החברה</b>: ({{ form.data.company.fields.name.value }})</p>
        <div class="is-flex is-align-items-center">
          <p><b>שם החברה</b>:</p>
          <div class="horizontal_space"></div>
          <input class="outlined" v-model="form.data.company.fields.name.value"
                :class="{ field_error: form.data.company.fields.name.has_error }"
                @focus="form.data.company.fields.name.has_error = false">
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex is-align-items-center">
          <p><b>אחוז השמה</b>:</p>
          <div class="horizontal_space"></div>
          <input class="outlined small_input" v-model="form.data.company.fields.percentage.value"
                :class="{ field_error: form.data.company.fields.percentage.has_error }"
                @focus="form.data.company.fields.percentage.has_error = false">
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex is-align-items-center">
          <p><b>ימים לדרישת תשלום</b>:</p>
          <div class="horizontal_space"></div>
          <input class="outlined small_input" v-model="form.data.company.fields.maturation_days.value"
                :class="{ field_error: form.data.company.fields.maturation_days.has_error }"
                @focus="form.data.company.fields.maturation_days.has_error = false">
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex">
          <p class="m-0"><b>פרטי יצירת קשר</b>:</p>
          <div class="horizontal_space"></div>
          <textarea class="outlined" v-model="form.data.company.fields.contact_details.value"></textarea>
        </div>
        <div class="vertical_space"></div>
        <div class="is-flex">
          <p class="m-0"><b>הודעה</b>:</p>
          <div class="horizontal_space"></div>
          <textarea v-model="form.data.company.fields.message.value"></textarea>
        </div>
      </div>
      <div v-if="!payload.is_modal && is_create">
        <div class="vertical_space"></div>
        <a @click="submit()" class="button is-info" :class="{ 'is-loading': is_submitting }">
          צור חברה חדשה
        </a>
      </div>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
      <div v-if="payload.is_modal" class="modal_footer">
        <a
          @click="submit()"
          :class="{ 'is-loading': is_submitting }"
          class="button is-info"
          >Submit</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'

export default {
  name: 'accounting-company-form',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    },
    onCloseSelectCompany: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    let env = this.$settings.get({ path: 'operation_name' })
    return {
      texts_helper: new TextsHelper(),
      env,
      show_company_search_form: false,
      is_loading: true,
      is_create: false,
      is_submitting: false,
      form: new this.$form({
        company: {
          fields: {
            id: {
              value: '',
              has_error: false,
              validations: []
            },
            name: {
              value: '',
              has_error: false,
              validations: ['Exists']
            },
            percentage: {
              value: '',
              has_error: false,
              validations: ['Exists', 'Number']
            },
            message: {
              value: '',
              has_error: false,
              validations: []
            },
            maturation_days: {
              value: '',
              has_error: false,
              validations: ['Number']
            },
            contact_details: {
              value: '',
              has_error: false,
              validations: ['Exists']
            },
            env_company_id: {
              value: this.payload.company.resource_id || this.payload.company.company_id,
              has_error: false,
              validations: ['Exists']
            },
            env: {
              value: env,
              has_error: false,
              validations: ['Exists']
            }
          },
          request_details: {
            method: 'post',
            url: '/create_accounting_company/',
            headers: 'admin_headers'
          },
          is_used: true
        }
      }),
      company_search_term: '',
      companies_search_results: [],
      billing_percentage: null,
      billing_days: null
    }
  },
  watch: {
    form: {
      handler () {
        this.updateParentForm()
      },
      deep: true
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getResourceTexts({
        current_type: this.payload.company.resource_type,
        current_resource_id: this.payload.company.resource_id
      }).then(texts => {
        this.billing_percentage = (this.texts_helper.getTextByDesignator(texts, 'billing_percentage') || {}).content
        this.billing_days = (this.texts_helper.getTextByDesignator(texts, 'billing_days') || {}).content
        this.getAccountingCompany()
      })
    },
    getAccountingCompany () {
      this.$network_utils.getAccountingCompany({ env: this.env, env_company_id: this.payload.company.resource_id }).then(response => {
        this.is_loading = false
        this.updateParentForm()
        if (response == undefined) {
          this.show_company_search_form = true
          return
        }
        this.selectCompany(response)
      })
    },
    updateParentForm () {
      this.$emit('input', this.form.data.company)
    },
    selectCompanySearchResult (company) {
      if (company.id == 0) {
        this.selectNewCompanyResult()
        return
      }
      if (this.payload.is_modal) {
        this.selectCompany(company)
        return
      }
      this.$emit('select_company', company)
    },
    selectCompany (company) {
      this.show_company_search_form = false
      this.form.data.company.request_details.method = 'put'
      this.form.data.company.request_details.url = '/update_accounting_company/'
      this.form.data.company.fields.id.value = company.id
      this.form.data.company.fields.name.value = company.name
      this.form.data.company.fields.percentage.value = this.billing_percentage || company.percentage
      this.form.data.company.fields.contact_details.value = company.contact_details
      this.form.data.company.fields.message.value = company.message
      this.form.data.company.fields.maturation_days.value = this.billing_days || company.maturation_days
    },
    selectNewCompanyResult () {
      this.form.data.company.fields.name.value = this.company_search_term
      this.companies_search_results = []
      this.show_company_search_form = false
      this.is_create = true
    },
    searchCompany () {
      if (this.company_search_term.length == 0) {
        this.companies_search_results = []
        return
      }
      this.$network_utils.searchAccountingCompany({ search_term: this.company_search_term }).then(response => {
        this.companies_search_results = response
        this.companies_search_results.push({
          id: 0,
          name: 'צור חדש'
        })
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_submitting = true
      response.promise.then((response) => {
        if (this.payload.is_modal) {
          this.remove(this.payload)
        }
        this.$emit('select_company', response[0])
        this.onCloseSelectCompany(response[0])
        this.$utils.emit('show_toast', { text: 'החברה נוצרה בהצלחה במערכת Accounting' })
        this.is_submitting = false
        this.is_create = false
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
